module.exports = __webpack_public_path__ + "static/yaren-e99573cd8df8cd8b61342d3febe2e968.png";